import { BrandSwitch } from './BrandSwitch';
import { TooltippedText } from './tooltipped-text';

interface ToggleFieldProps {
  title: string;
  description?: string;
  checked: boolean;
  onChange: (checked: boolean) => void;
  className?: string;
  tooltipContent?: string;
  disabled?: boolean;
}

export function ToggleField({
  title,
  description,
  checked,
  onChange,
  tooltipContent,
  disabled = false,
}: ToggleFieldProps) {
  return (
    // eslint-disable-next-line jsx-a11y/label-has-associated-control
    <label
      className={`tw:bg-zinc-50 tw:rounded-lg tw:p-4 tw:!flex tw:justify-between tw:relative tw:z-0 tw:dark:border-white/10 tw:dark:bg-white/5 tw:dark:shadow-none ${
        disabled
          ? `tw:cursor-not-allowed tw:opacity-90 ${checked ? 'tw:bg-brand-green-0/5 tw:border tw:border-brand-green-0/20 tw:dark:bg-brand-green-1/5 tw:dark:border-brand-green-1/20' : ''}`
          : 'tw:hover:cursor-pointer'
      }`}
    >
      <div className="tw:items-center">
        <div className="tw:text-sm tw:inline-block tw:pl-[0.15rem] tw:dark:text-white">{title}</div>
        {tooltipContent && (
          <span className="tw:ml-1">
            <TooltippedText tooltipContent={tooltipContent}>
              <i className="far fa-circle-info tw:text-brand-green-0 ml-2 tw:text-sm" />
            </TooltippedText>
          </span>
        )}
        <div className="tw:text-xs tw:text-zinc-500 tw:font-light tw:dark:text-zinc-400">
          {description}
        </div>
      </div>
      <div className="tw:flex tw:items-center">
        <BrandSwitch checked={checked} onChange={onChange} disabled={disabled} />
      </div>
    </label>
  );
}
